<template>
    <div class="container">

        <!--        <form id="login" name="login" action="https://cms.corendonairlines.com/Kullanici/Giris" method="post" target="_blank">-->
        <!--            <div class="content">-->
        <!--                <h3 class="form-title">Giriş Yapınız</h3>-->
        <!--                <div class="form-group">-->
        <!--                    <label class="control-label visible-ie8 visible-ie9"></label>-->
        <!--                    <div class="input-icon">-->
        <!--                        <i class="fa fa-envelope"></i>-->
        <!--                        <input class="form-control validate[required]" type="text" autocomplete="off"-->
        <!--                               placeholder="E-Mail" id="txtusername" name="txtusername" tabindex="1"-->
        <!--                               :value="cmsForm.email"-->
        <!--                               fdprocessedid="6vcm0p">-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--                <div class="form-group">-->
        <!--                    <label class="control-label visible-ie8 visible-ie9"></label>-->
        <!--                    <div class="input-icon">-->
        <!--                        <i class="fa fa-lock"></i>-->
        <!--                        <input class="form-control validate[required]" type="password" autocomplete="off"-->
        <!--                               placeholder="Password" id="txtpassword" name="txtpassword" tabindex="2"-->
        <!--                               :value="cmsForm.sifre"-->
        <!--                               fdprocessedid="g72fdu">-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--                <div class="form-group">-->
        <!--                    <div class="col-md-6" style="padding-left:0px; padding-right: 0px;">-->
        <!--                        <a href="javscript:void(0);" class="btn pull-rightleft" style="color:#fff;" tabindex="4"-->
        <!--                           id="dilsecimi">Dil Seçimi</a>-->
        <!--                    </div>-->
        <!--                    <div class="col-md-6" style="padding-left:0px; padding-right: 0px;">-->
        <!--                        <select class="form-control" id="ddldil" fdprocessedid="l1j3i8" :value="cmsForm.dil">-->
        <!--                            <option value="TR" selected="">Türkçe</option>-->
        <!--                            <option value="EN">English</option>-->
        <!--                        </select>-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--                <div class="form-group">-->
        <!--                    <canvas id="canvas" style="display:none;" width="100" height="40"></canvas>-->
        <!--                </div>-->
        <!--                <div class="form-group">-->
        <!--                    <input name="code" id="code" style="display:none;" class="form-control">-->
        <!--                </div>-->
        <!--                <div class="form-group">-->
        <!--                    <a href="/Kullanici/ParolaAnimsa?lang=tr" class="btn pull-rightleft"-->
        <!--                       style="color:#fff;margin-top:10px;" tabindex="4" id="btnsifremiunuttum">Şifremi Unuttum</a>-->
        <!--                    <button id="btnGiris" type="submit" text="Giriş" class="btn green pull-right"-->
        <!--                            style="margin-top:10px;" tabindex="3" fdprocessedid="j59vf">Giriş Yap-->
        <!--                    </button>-->
        <!--                    <div class="copyright">2023 © Corendon Airlines</div>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--        </form>-->


        <button @click="GirisYap">Giriss</button>
        <button @click="GirisYap1">Giris iframe</button>
        <iframe id="cmsframe" height="1000" width="1200" src="https://cms.corendonairlines.com/Kullanici/Giris">

        </iframe>


        <div>
            <CorendonLoading/>
        </div>
    </div>

</template>

<script>
    import {mapState} from "vuex";
    import {loadingMixin} from "../../utils/mixins";
    import CorendonLoading from "../../components/ui/CorendonLoading";
    import $ from "jquery"
      import axios from "axios"

    export default {
        name: "CmsLogin",
        mixins: [loadingMixin],
        data() {
            return {
                rootSera: "",
                cmsForm: {
                    email: 'rcapraz@corendon-airlines.com'
                    , sifre: 'AMsY<>5['
                    , dil: "TR"
                    , benihatirla: false
                }
            }
        },
        components: {
            CorendonLoading
        },

        methods: {

            getUrlParameter(sParam) {
                var sPageURL = decodeURIComponent(window.location.search.substring(1)),
                    sURLVariables = sPageURL.split('&'),
                    sParameterName,
                    i;
                for (i = 0; i < sURLVariables.length; i++) {
                    sParameterName = sURLVariables[i].split('=');
                    if (sParameterName[0] === sParam) {
                        return sParameterName[1] === undefined ? true : sParameterName[1];
                    }
                }
            },

            GirisYap() {
               // document.getElementById("btnGiris").click();
                //this.$refs.txt.click();
                let mainRoute = "https://cms.corendonairlines.com";
                $.ajax({
                    type: "POST",
                    url: 'https://cms.corendonairlines.com/Kullanici/Giris',
                    data: {
                        email: this.cmsForm.email,
                        sifre: this.cmsForm.sifre,
                        dil: this.cmsForm.dil,
                        benihatirla: false
                    },
                    success: function (response) {
                        if (response == "2") {
                            console.log(response)
                        } else if (response == "-1") {
                            console.log(response)

                        } else if (response == "3") {
                            console.log(response)

                        } else {
                            window.open(mainRoute.toString(), '_blank');
                        }
                    }
                })
                axios.post('https://cms.corendonairlines.com/Kullanici/Giris', this.cmsForm)
                    .then(function (response) {
                        console.log(response)
                        console.log(response.data)
                        window.open(mainRoute.toString(), '_blank');
                    }.bind(this));

            },
            GirisYap1() {


                //let html = document.getElementById("cmsframe").contentDocument.document.getElementById("txtusername");

                //console.log(html)
                //console.log(document.getElementById('cmsframe').innerText)
                document.getElementById("cmsframe").contentWindow.contentWindow.getElementById('txtusername').value = 'rcapraz@corendon-airlines.com'
                document.getElementById('txtpassword').value = 'sdfsdf'
                // console.log(document.getElementById("cmsframe"))
                // let txtusername = document.getElementById('cmsframe').contentWindow.contentWindow.getElementById('txtusername').value;
                // document.getElementsByTagName('iframe')[0].contentDocument.document.getElementById("txtusername").value = 'adfsdfsdf';
                // document.getElementById('txtusername').value = 'test'
                // document.getElementById('txtpassword').value = 'CAI'

                //console.log(txtusername)





            },

            iframeEvent(event) {
                //Verify App Domain
                if(event.origin !== 'https://cms.corendonairlines.com/Kullanici/Giris') return;
                console.log('data received:  ' + event.data);
            }
        },
        mounted(){
            window.addEventListener("message", this.iframeEvent, false);
        },

        computed: {
            ...mapState('sera', ['seraUserInfo', 'seraUserInfos']),
            ...mapState("auth", ["user"]),

        },

        async beforeMount() {
            // await this.GirisYap();
        }

    }

</script>

<style scoped>
    .form-check-input:checked {
        background-color: #56759c;
    }
</style>
